import "./Skeleton.css"

// https://egghead.io/lessons/aria-use-wai-aria-attributes-to-improve-web-accessibility-of-your-skeleton-loader
// https://adrianroselli.com/2020/11/more-accessible-skeletons.html
// https://ux.stackexchange.com/questions/135956/does-a-skeleton-loader-need-to-be-accessible

function Skeleton() {
    return (
        <div>
            <div>
                <span className="skeleton-loader top" />
            </div>
            <div>
                <span className="skeleton-loader bottom" />
            </div>
        </div>
    )
}

export default Skeleton
